import store from "@/store";


export function isAliveToken(success = () => {
}, error = () => {
}) {
  if (store.getters['user/isCheckExpired']()) {
    store.dispatch('user/CHECK_TOKEN_ALIVE').then(
        () => {
          success()
        }
    ).catch(error)
  } else {
    success()
  }
}

export function goToLoginPage() {
  document.location.href = process.env.VUE_APP_LOGIN_HOST + `?from=${document.location.href}`
}
